/** Shared email format check (single source of truth across forms). */
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isValidEmail(value: string): boolean {
  return EMAIL_RE.test(value.trim());
}

export function getEmailValidationMessage(value: string): string | null {
  const email = value.trim();
  if (!email || isValidEmail(email)) return null;
  if (/\s/.test(email)) return 'Email addresses cannot contain spaces.';

  const atIndex = email.indexOf('@');
  if (atIndex === -1) return 'Email address must include an @ symbol.';
  if (atIndex === 0) return 'Enter a name before the @ symbol.';
  if (atIndex !== email.lastIndexOf('@')) return 'Email address can contain only one @ symbol.';

  const domain = email.slice(atIndex + 1);
  if (!domain) return 'Enter a domain after the @ symbol.';
  if (!domain.includes('.')) return 'Enter a complete domain, such as example.com.';

  return 'Enter an email in the format name@example.com.';
}
